/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'Проверка AI',
    AIReviewFailed: 'Проверка AI не пройдена',
    AIReviewPassed: 'Проверка AI пройдена',
    AIReviewStatus: 'Статус проверки AI',
    AIReviewing: 'Проверка AI проходит',
    America: {},
    CheckSupportInstall: 'Проверьте, поддерживается ли модификация',
    ImporterCommunityDisplayName: 'Отображаемое имя сообщества импортеров',
    ImporterContactEmail: 'Контактный адрес электронной почты импортера',
    IndicatorLight: 'световой индикатор',
    Instruction: 'Уведомление',
    MostPicture4OrVideo: '(Максимум 4 фотографии / 1 видео)',
    PleaseContactPersonnelCommunicating: 'Обратитесь к персоналу CFMOTO и сообщите им',
    Redemptionservice: 'Услуга списания',
    USD: {},
    UnbindingApplicationCommitment: {},
    aboutAccount: 'О счете',
    aboutVehicle: 'О транспортном средстве',
    accountApplyRejected: 'Запрос на удаление учетной записи отклонен',
    accountCancel: 'Запрос на удаление учетной записи',
    accountDeletExplain: 'Руководство по удалению учетной записи',
    accountDelete: 'Удаление учетной записи',
    accountDeleted: 'Аккаунт удален',
    accountFormatError: 'Неправильный формат учетной записи/пользователь не существует. Подберите соответствующий копирайтинг в зависимости от фактической причины',
    accountNumber: 'Номер аккаунта',
    action: 'Операция',
    actionFail: 'операция не удалась',
    actionSuccess: 'Операция прошла успешно',
    activeScore: 'Активный скоринг',
    activeTrigger: 'Пользователи активно запускают (О приложении — Перейти к рейтингу)',
    activity: 'Мероприятие',
    activityCancel: 'Отмена мероприятия',
    activityCover: 'Обложка мероприятия',
    activityDetails: 'Подробность о мероприятии',
    activityId: 'ID действия',
    activityList: 'Список мероприятий',
    activityManagement: 'Управление мероприятием',
    activitySearch: 'Поиск мероприятий',
    activityTime: 'Время мероприятия',
    activityTitle: 'Название мероприятия',
    activityVenue: 'Место проведения мероприятия',
    adaptable: 'годиться',
    add: 'Добавить',
    addAccountDeletExplain: 'Добавить уведомление об удалении аккаунта',
    addAuthenticationTime: 'Добавление времени аутентификации',
    addCanadaPrivacyPolicy: 'Добавить политику конфиденциальности Канады',
    addCanadaTelematicsPolicy: 'Добавить соглашение о телематике с Канадой',
    addCanadaUserPolicy: 'Добавить пользовательское соглашение для Канады',
    addDashcamHelp: 'Добавлена помощь видеорегистратора',
    addDataDeletExplain: 'Добавить уведомление об удалении данных',
    addEmail: 'Новый E-mail',
    addExhibitionCategory: {},
    addExhibitionSeries: {},
    addHelpConfiguration: 'Добавьте помощь в описании конфигурации',
    addInformationCategory: 'Добавить новую категорию информации',
    addInformationContent: 'Добавить новый информационный контент',
    addKolUserAuthentication: 'Добавление аутентификации пользователей KOL',
    addPicture: 'Добавить изображение',
    addPrivacyAgreement: 'Добавить протокол',
    addPrivacySubmitSure: 'Дата вступления в силу и описание изменения новой политики конфиденциальности не могут быть изменены после подачи. Подтвердите отправку.',
    addPushConfiguration: 'Добавить пуш-уведомления',
    addQuestion: {},
    addSdkStaement: 'Добавить заявление SDK',
    addServiceIntroduce: 'Введение новых услуг',
    addShowroomModel: 'Добавить модель зала',
    addThisUser: 'Добавить этого абонента',
    addTopic: 'Добавить тему',
    addUser: 'Добавить абонента',
    addUserAgreement: 'Добавить протокол пользователя',
    addUserRole: 'Добавить роль пользов.',
    addVehicleModel: 'Новые модели',
    addVehicleModelCategory: 'Новые категории автомобилей',
    addVideo: 'Добавить видео',
    addedBy: 'Добавлено',
    additionalFeedback: 'Дополнительная обратная связь',
    administratorUnbind: 'Отвязка админ-ра',
    afternoon: 'Пополудни',
    agreeServiceAgreement: 'Активируя услугу, вы соглашаетесь с условиями Соглашения об услугах',
    agreeSignOut: 'Согласие на расторжение договора',
    agreementContent: 'Соглашение',
    all: 'Bсе',
    allArea: 'Целевая страна/регион',
    allComment: 'Все комментарии',
    allImportSuccess: 'Импорт завершен. Все успешно импортировано',
    allServicesSimultaneously: 'Все услуги',
    allUser: 'Все пользователи',
    allVehicleModel: 'Все модели',
    alreadyOver: 'Все здесь',
    ambientLightControl: 'Управление атмосферной подсветкой',
    amount: 'Сумма',
    android: 'Андроид',
    answer: {},
    answerOta1: 'OTA означает, что автомобиль загружает новейшее программное обеспечение из облака через сотовую сеть, и вы можете обновить автомобиль онлайн через CFMOTO RIDE, чтобы постоянно оптимизировать езду',
    answerOta2: 'При появлении новой версии TFT-дисплея, которую можно обновить, вы получите уведомление об обновлении. Если %s отображается внизу текущей страницы, это означает, что TFT-дисплей автомобиля не нуждается в обновлении.',
    answerOta3: 'Вы можете нажать %s в правом верхнем углу, чтобы заранее узнать дополнительные инструкции по эксплуатации OTA.',
    anyCar: 'Есть автомобиль?',
    appMessagePushCountLimit: 'Вы достигли лимита push-уведомлений на этот месяц (2 раза/месяц). Отредактированный контент можно сохранить как черновик. Сохранить?',
    appPush: 'Push-уведомление в приложении',
    appRating: 'Управление механизмом начисления очков',
    appType: 'Телефонная система',
    appVersion: 'версия приложения',
    applicableCountry: {},
    applicableCountryName: {},
    applyTime: 'Время применения',
    applyUnbinding: 'Применить отвязать',
    appointmentReleaseTime: 'Время выхода записи',
    approval: 'Одобрение',
    arrivalNumberDescription: 'количество устройств, получивших уведомление',
    arrivalNumberDescription0: 'Фактическое количество прибывших на терминал устройства после отправки пуш-уведомлений (прибытия по истечению 5 дней не будут учитываться)',
    arrivalNumberVolume: 'Количество прибывших',
    askAllowUserSpeakInCommunity: 'Разрешить заблокированному абоненту опубликовать пост в сообществе',
    askApproveIt: 'Одобрить',
    askDeleteCategory: {},
    askDeleteInformactionCategory: 'Удалить ли эту категорию информации',
    askDeleteInformationContent: 'Удалять ли информационный контент',
    askDeleteKolUserAuthentication: 'Подтвердить удаление этой аутентификации пользователя KOL?',
    askDeleteOfficialAuth: 'Удалить официальную авторизацию для этого аккаунта?',
    askDeleteQuestion: {},
    askDeleteThisActivity: 'Удалить это мероприятие',
    askDeleteThisBanner: 'Удалить это Banner',
    askDeleteThisComment: 'Вы уверены, что хотите удалить этот комментарий',
    askDeleteThisPost: 'Удалить это пост',
    askDeleteThisTopic: 'Удалить эту тему',
    askDeleteVehicleType: 'Подтвердить удаление автомобиля',
    askDeleteVehicleTypeCategory: 'Удалить ли эту категорию модели',
    askDeleteVehicleTypeDetails: 'Удалить ли информацию о модели автомобиля',
    askDeleteVehicleTypeSeries: 'Удалить ли этот модельный ряд',
    askLogout: 'Вы действительно хотите выйти из системы?',
    askNotApproveIt: 'Не одобрить',
    askSaveSettings: 'Настройки еще не сохранены, хотите их сохранить?',
    associatedPostNumber: 'Количество соответствующих постов',
    associatedPosts: 'Соответствующие посты',
    associatedVehicle: 'связанное транспортное средство',
    assoclatedContent: 'Связанный контент',
    atmosphereCContent: 'Настройки еще не сохранены, хотите их сохранить?',
    atmosphereContent1Msg1:
      'После того, как функция включена, мобильный телефон включает Bluetooth, и приложение продолжает работать. При приближении к автомобилю от дальнего до ближнего расстояния автомобиль может быть автоматически разблокирован и включен.',
    atmosphereContent1Msg2: 'Если он обычно не разблокирован и не включен, нажмите кнопку питания автомобиля, чтобы разблокировать и включить питание.',
    atmosphereContent1Msg3: 'Близость автоматическая разблокировка будет активирована только один раз до отключения bluetooth',
    atmosphereContent2Msg1: 'После того, как функция включена, транспортное средство автоматически отключается через 5 секунд после трех условий выключения транспортного средства, скорость транспортного средства составляет 0 и храм брошен',
    atmosphereContent2Msg2: 'Запуск транспортного средства в течение периода автоматического отключения, скорость транспортного средства не 0, или висок отложен отменит автоматическое отключение',
    atmosphereContent3Msg1:
      'После того, как функция включена, когда автомобиль выключен, мобильный телефон включает Bluetooth, и APP продолжает работать или несет физический ключ. При приближении к автомобилю от дальнего до ближнего света огни автомобиля мигают, приветствуя гостей.',
    atmosphereContent3Msg2: 'Чтобы предотвратить потерю мощности транспортного средства частыми триггерами, после того, как приветственная функция будет активирована дважды в течение 30 секунд, она не возобновится до 30 минут позже.',
    atmosphereContent4Msg1: 'После включения функции дальний и ближний свет автоматически включается на 10 секунд после выключения автомобиля.',
    atmosphereIntroduce1: 'Рядом с инструкциями по автоматической разблокировке',
    atmosphereIntroduce2: 'инструкции по автоматическому отключению питания',
    atmosphereIntroduce3: 'Инструкции по автоматическому пробуждению',
    atmosphereIntroduce4: 'Задержка выключения света',
    atmosphereSetINfo: 'Новые настройки вступят в силу в течение 1-3 минут после включения питания автомобиля. Убедитесь, что автомобиль находится в зоне хорошего сигнала.',
    auditStatus: 'Статус проверки',
    authType: 'Тип авторизации',
    authenticatedName: 'Аутентифицированное имя',
    avatar: 'Фото проф-я',
    backApply: 'отозвать заявку',
    backApplySuccess: 'отзыв заявки успешен',
    backHome: 'Вернуться на главную страницу',
    bannerDisplayImages: 'Изображение баннера',
    bannerList: 'Список Banner',
    bannerManagement: 'Управление Banner',
    bannerPictrure: 'Рисунок Banner',
    bannerSearch: 'Поиск Banner',
    bannerTitle: 'Заголовок баннера',
    baseService: 'Standard Edition\n',
    baseServicePay: 'Оплата Standard Edition',
    baseServiceResetTimeRule: 'Время сброса базовой услуги не может быть позже текущего времени',
    batchImport: 'Пакетный импорт',
    batchUser: 'Групповые пользователи',
    beijingTime: 'время UTC+8',
    belogCategory: 'категория',
    belongCategory: {},
    bindDevice: 'Привяжите устройство',
    bindEmail: 'Привязать электронную почту',
    bindVehicle: 'Привязать транспортное средство',
    bindingStatus: 'Статус отвязки',
    bindingText1: '1.\tТелематические услуги',
    bindingText10: '1.1.2.\tОбеспечение планирования маршрута во время навигации, включая расчет расстояния между транспортными средствами и пешую навигацию с целью поиска транспортного средства .',
    bindingText11: '1.2.\tНаправление необходимых уведомлений Заказчику исходя из состояния автомобиля.',
    bindingText12:
      '1.2.1.\tCFMOTO отправляет Клиенту уведомления о техническом обслуживании транспортного средства (например, исходя из общего расстояния, пройденного Клиентом, времени, когда Клиент покупает транспортное средство, требований времени или расстояния для технического обслуживания транспортного средства) .',
    bindingText13:
      '1.2.2.\tНа основании данных о транспортном средстве CFMOTO будет отправлять Клиенту уведомления о нештатных ситуациях; включая анализ данных OEM (в зависимости от модели) для обеспечения обслуживания клиентов и последующей оптимизации автомобиля .',
    bindingText14: '1.3.\tПомощь в анализе причин аварии, если Заказчик сообщает о серьезной аварии ТС.',
    bindingText15:
      '1.3.1.\tВ случае серьезной аварии Транспортного средства, например, когда Транспортное средство переворачивается или переворачивается на бок во время движения, CFMOTO окажет поддержку Клиенту по запросу в выяснении того, является ли авария следствием дефекта Транспортного средства или других обстоятельств. Запрос должен быть отправлен в CFMOTO Клиентом через местного дистрибьютора/партнера по продажам, указанного в Договоре купли-продажи автомобиля.',
    bindingText16: '1.3.2.\tНасколько это позволяют имеющиеся данные, CFMOTO оценит данные относительно причины аварии и предоставит Заказчику соответствующий отчет.',
    bindingText17: '1.4.\tПомощь Клиенту в восстановлении ТС после его утери .',
    bindingText18:
      '1.4.1.\tЕсли Транспортное средство потеряно, CFMOTO предоставит Клиенту данные о местонахождении Транспортного средства и другие полезные данные о состоянии Транспортного средства (например, место последней активации, текущий статус транспортного средства и т. д.) по запросу и при наличии.',
    bindingText19: '1.4.2.\tЗапрос должен быть отправлен в CFMOTO Клиентом через местного дистрибьютора/партнера по продажам, указанного в Договоре купли-продажи автомобиля.',
    bindingText2:
      'CFMOTO Powersports, Inc. (далее именуемая « CFMOTO » ) предоставляет услуги автомобильной телематики клиенту, купившему автомобиль CFMOTO (далее именуемому «Клиент» ). Для этих услуг CFMOTO использует данные, записанные Транспортным средством о транспортном средстве и его поведении за соответствующий период времени. Подробно это касается следующих данных:',
    bindingText20: '1.5.\tСообщение о проблемах после продажи .',
    bindingText21: '1.5.1.\tCFMOTO дистанционно собирает уведомления о кодах ошибок, отправленные ТС в случае неисправности его компонентов, и предоставляет соответствующую информацию по запросу Клиента непосредственно Клиенту.',
    bindingText22: '1.5.2.\tЗапрос должен быть отправлен в CFMOTO Клиентом через местного дистрибьютора/партнера по продажам, указанного в Договоре купли-продажи автомобиля.',
    bindingText23: '2.\tОграничения и исключения обслуживания',
    bindingText24:
      '2.1.\tПрямо указано, что конструктивные или другие технические изменения Транспортного средства могут ограничить предоставление услуг или даже сделать его невозможным, поскольку услуги зависят от правильного предоставления данных о транспортном средстве.',
    bindingText25: '2.2.\tЕсли такие услуги не могут быть предоставлены из-за работы сторонних сетей передачи данных или телекоммуникационных сетей, любая ответственность CFMOTO исключается.',
    bindingText26: '3.\tКонфиденциальность',
    bindingText27:
      'CFMOTO будет соблюдать применимые правила защиты данных при обработке персональных данных, связанных с автомобилем CFMOTO . Условия политики конфиденциальности C FMOTO изложены в этом приложении CFMOTO RIDE . Являясь дополнением к политике конфиденциальности , его уведомление соответствует политике конфиденциальности . И Клиент может обратиться к политике конфиденциальности для некоторого контента, связанного с обработкой данных, не охваченного этим уведомлением.',
    bindingText28: '4.\tОбслуживание клиентов',
    bindingText29:
      '4.1.\tКлиент может свободно отправлять вопросы, комментарии или проблемы, связанные с конфиденциальностью , по адресу CFMOTORIDEAPP@cfmotousa.com или писать по адресу: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. Клиент также может позвонить по телефону. Отдел по работе с клиентами CFMOTO по телефону (888) 823-6686. ',
    bindingText3: 'Данные о поведении пользователя за рулем : включая ускорение, замедление, скорость, изгиб, время последнего вождения и последний пробег вождения .',
    bindingText30: '5.\tРедакции _',
    bindingText31: '5.1.\tCFMOTO оставляет за собой право изменять это уведомление в любое время, но мы опубликуем изменения на CFMOTO RIDE. Приложение и/или предоставить уведомление, прежде чем мы сделаем это надлежащим образом.',
    bindingText4:
      'Данные о состоянии транспортного средства: относятся к состоянию транспортного средства в реальном времени, включая режим вождения, остаточное топливо, мгновенную экономию топлива, пробег, передачу транспортного средства в реальном времени, частоту вращения двигателя, давление в шинах, температуру шин, данные о напряжении аккумулятора. , температура охлаждающей жидкости, состояние электронного замка, версия программного обеспечения интеллектуального устройства, мощность сигнала интеллектуальных устройств, текущая настройка приборной панели.',
    bindingText5:
      'Данные тревоги автомобиля: данные тревоги, которые будут отправлены, если определенные данные превышают заданное значение, например, температура двигателя, превышение скорости, чрезмерное время вождения, высокая температура охлаждающей жидкости, ненормальное движение автомобиля, ненормальное давление в шинах, вибрация, сброс, столкновение и т . д . .',
    bindingText6: 'Информация о неисправности автомобиля: относится к кодам неисправностей, сообщаемым каждой внутренней частью автомобиля.',
    bindingText7: 'Данные о местонахождении транспортного средства: относится к конкретному географическому местонахождению транспортного средства.',
    bindingText8: '1.1.\tПредоставление _ Клиенту с услугами, связанными с автомобилем, через ПРИЛОЖЕНИЕ CFMOTO RIDE .',
    bindingText9:
      '1.1.1.\tПотребители могут удаленно управлять транспортными средствами через приложение CFMOTO RIDE (включая просмотр местоположения транспортного средства, настройку информации о транспортном средстве и функций, дистанционное управление состоянием транспортного средства и т. д.).',
    bindingUser: 'Привязка пользователя',
    bothServices: 'Обе услуги',
    bound: 'Привязано',
    businessType: 'Вид деятельности',
    button: 'кнопки',
    callbackedApply: 'Вы отозвали заявку на удаление учетной записи в yyyy-MM-dd HH:mm:ss',
    callbackedApplySyncTip:
      'Ваш запрос на удаление учетной записи был отправлен в yyyy-MM-dd HH:mm:ss. Мы безвозвратно удалим вашу учетную запись и связанные с ней данные через 15 дней после получения запроса. После удаления вы больше не сможете пользоваться услугой CFMOTO RIDESYNC. Чтобы отменить удаление аккаунта, пожалуйста, повторно посетите веб-страницу или войдите в APP в течение 15 дней, чтобы отозвать запрос на удаление учетной записи.',
    callbackedApplyTip:
      'Ваш запрос на удаление учетной записи был отправлен в yyyy-MM-dd HH:mm:ss. Мы безвозвратно удалим вашу учетную запись и связанные с ней данные через 15 дней после получения запроса. После удаления вы больше не сможете пользоваться услугой CFMOTO RIDE. Чтобы отменить удаление аккаунта, пожалуйста, повторно посетите веб-страницу или войдите в APP в течение 15 дней, чтобы отозвать запрос на удаление учетной записи.',
    canadaPrivacyPolicy: 'Политика конфиденциальности Канады',
    canadaTelematicsPolicy: 'Канадское соглашение по телематике',
    canadaUserPolicy: 'Пользовательское соглашение для Канады',
    canadianAgreementText: 'Текст канадского соглашения',
    cancel: 'Отменить',
    cancellationAgreement: 'аннулировать соглашение',
    cancelled: 'Отменено',
    carOwner: 'Владелец',
    carUserScore: 'Рейтинг владельцев транспортных средств',
    cardPass: 'Успешное подтверждение личности!',
    cfmotoName: 'CFMOTO',
    changeCodeValidate: 'Переключение на аутентификацию по проверочному коду',
    changeDescriptionType: 'изменить описание',
    changeDescriptionTypeSelectNo: 'Не предполагает изменения правил обработки персональной информации',
    changeDescriptionTypeSelectYes: 'Изменения в правилах обработки личной информации',
    changeEmail: 'Изменить электронную почту',
    changeEmailInfo: 'Переключиться на электронную почту',
    changeFail: 'Изменение статуса не удалось',
    changeOne: 'Изменять',
    changePassValidate: 'Переключение на аутентификацию по паролю',
    changePasswordFailed: 'Не удалось изменить пароль',
    changePasswordSuccessful: 'Пароль успешно изменен',
    changePhoneInfo: 'Переключиться на номер телефона',
    changeStore: 'Изменить магазин',
    changeSuccess: 'Статус успешно изменен',
    channelType: 'канал обратной связи',
    characterLimitExceeded: 'Превышен лимит символов',
    checkConfigurationTwo: 'Китайский или английский %s не настроен полностью, проверьте',
    checkCopyWriting: 'Содержимое на китайском или английском языке не заполнено, проверьте',
    checkEmpty: '%s пуст, пожалуйста, проверьте',
    checkEmptyEnglish: 'Английский не завершён. Проверьте',
    checkTriggerType: 'Не заполнено условие спускового механизма, проверьте',
    checkUpdate: 'проверить обновления',
    cityFilter: 'Городской фильтр',
    clickImmediateFeedback: 'Нажмите, чтобы оставить отзыв сейчас',
    clickNumber: 'Количество кликов',
    clickNumberDescription: 'количество уведомлений, на которые нажали пользователи',
    clickNumberVolume: 'Количество кликов',
    clickToFeedback: 'Нажмите для обратной связи',
    clicks: 'Клики',
    closeNum: 'закрытие',
    closeTask: 'Задача отменена',
    code: 'Код проверки',
    colorPicture: 'Цветовой блок',
    comment: 'Комментарий',
    commentContent: 'Комментарии',
    commentList: 'Список комментариев',
    commentNumber: 'Количество комментариев',
    commentTime: 'Время комментария',
    communication: 'в общении',
    community: 'Сообщество',
    communityManagement: 'Управление сообществом',
    communityRule: 'Правило сообщества',
    completePuzzle: 'Пожалуйста, решите головоломку',
    completed: 'завершенный',
    condition: 'состояние',
    configureLanguage: 'Настроить язык',
    configurePicture: 'Настроить изображение',
    confirm: 'Подтвердить',
    confirmDeletePictures: 'Подтвердите удаление этого изображения',
    confirmRedeem: 'Подтвердить списание',
    confirmReviewNoPass: 'Подтвердите не успешность обзора',
    confirmReviewPass: 'Подтвердите успешность обзора',
    consultDealer: 'Проконсультируйтесь с местным дилером',
    contact: 'Ваше заявление на удаление учетной записи было отклонено. Если у вас есть какие-либо вопросы, свяжитесь с нами по адресу it@cfmoto.com для консультации.',
    contactMail: 'Адрес электронной почты',
    contactMethod: 'Контакт',
    contactUs: 'Связаться с нами',
    content: 'Содержание',
    contentType: 'Тип содержания',
    copyFail: 'Не удалось скопировать',
    copyLink: 'Копировать ссылку',
    copySuccess: 'Скопировано успешно',
    copyWriting: 'Всплывающее содержимое',
    country: 'Страна/регион',
    countryCode: 'Код страны',
    countryName: 'Страна',
    countryNumber: 'Код страны',
    countryRegion: 'Страна/регион',
    create: 'Новое дополнение',
    createBy: 'Создатель',
    createStore: 'Создать магазин',
    createTime: 'время создания',
    cs_CZ: 'Чешский',
    currency: 'Валюта',
    currentConfig: {},
    currentCountryStoreTotal: 'Общее количество магазинов в текущей стране',
    currentRedemptionRatio: 'Текущий коэффициент списания',
    currentTime: 'Текущее время',
    customPage: 'Пользовательская страница',
    customSettings: 'Пользов. столбцы',
    dashcamHelp: 'Помощь видеорегистратора',
    dataDeletExplain: 'Руководство по удалению данных',
    dataDelete: 'Удаление данных',
    dataDeleteApply: 'Запрос на удаление данных',
    dataFormatError: 'Ошибка формата данных',
    dataPermissionScope: 'Область разрешения данных',
    dataType: 'Тип данных',
    dayOne: 'дней один раз',
    days: 'день',
    daysAgo: '%s дней назад',
    de_DE: 'Немецкий',
    dealDate: 'Время обработки',
    dealerOperationList: 'Список операций дилера',
    dealerOperationQuery: 'Запрос на операции дилера',
    dealerOperationRecord: 'Запись операции дилера',
    dealerStore: 'Дилерские магазины',
    dealerStoreImportTempateName: 'Шаблон импорта магазина дилеров',
    dealerStoreQuery: 'Запрос по дилерским магазинам',
    dealers: 'Импортер',
    default: 'По умолчанию',
    defaultMap: 'Kарта по умолчанию',
    delete: 'Удалить',
    deleteAccountSYNCStep: 'Вы можете выполнить следующие действия, чтобы запросить удаление вашей учетной записи CFMOTO RIDESYNC',
    deleteAccountStep: 'Вы можете выполнить следующие действия, чтобы запросить удаление вашей учетной записи CFMOTO RIDE',
    deleteDataSYNCStep: 'Вы можете выполнить следующие действия, чтобы запросить удаление своих данных CFMOTO RIDESYNC',
    deleteDataStep: 'Вы можете выполнить следующие действия, чтобы запросить удаление своих данных CFMOTO RIDE',
    deleteFail: 'Не удалось удалить',
    deleteFinish: 'Удаление завершено',
    deleteKolUserAuthentication: 'Удаление аутентификации пользователей KOL',
    deleteStore: 'Удалить магазин',
    deleteSuccess: 'Успешно удалено',
    deleteTip: 'Вы уверены, что хотите удалить эту запись? После удаления информация не может быть восстановлена',
    deleteVersionWarn: 'Удалить ли эту запись версии',
    deleteVideo: 'Удалить это видео?',
    detailAddress: 'Подробный адрес',
    details: 'Детали',
    determine: 'Да',
    deviceCodeGet: 'Получить код устройства:',
    deviceContent:
      'Код оборудования приемника электронного ограждения (называемого ключом) представляет собой строку из 10-значных кодов. Код оборудования, QR-код и знак CE напечатаны на серебристой самоклеящейся наклейке из ПВХ. Всего этикеток три, одна прикреплена к кузову автомобиля (чтобы увидеть, нужно поднять подушку сиденья); два других помещаются в сумку для аксессуаров автомобиля. (Пользователям рекомендуется прикрепить этикетку к руководству по эксплуатации автомобиля или на пульте дистанционного управления)\nПожалуйста, нажмите и удерживайте кнопку «ВКЛ», чтобы открыть ключ, и поместите QR-код на обратной стороне ключа в рамку сканирования.',
    deviceNo: 'Связанный номер устройства',
    deviceNumber: 'Номер устройства',
    deviceTitle: 'Проверьте код',
    digitalKey: 'цифровой ключ',
    digitalKeyDesc: 'Нет необходимости носить с собой физический ключ, поддержка разблокировки автомобиля после подключения через приложение Bluetooth (поддерживается некоторыми моделями)',
    directRelease: 'Прямое опубликование',
    disagree: 'Не согласен',
    displayNumberDescription: 'количество уведомлений, отображённых на устройствах',
    displayNumberVolume: 'Количество показов',
    displayOrder: {},
    displayPicture: {},
    donwloadTemplateDescription: {},
    download: 'Скачать',
    downloadFailFile: 'Скачать файл с ошибкой',
    downloadSuccessful: 'Загрузка прошла успешно',
    downloadTemplate: 'Скачать шаблон',
    downloading: 'Загружается...',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'редактировать',
    editAccountDeletExplain: 'Уведомление об удалении аккаунта',
    editActivity: 'Редактирование мероприятие',
    editAppRating: 'Изменить механизм рейтинга',
    editBanner: 'Редактировать Banner',
    editCanadaPrivacyPolicy: 'Изменить политику конфиденциальности Канады',
    editCanadaTelematicsPolicy: 'Изменить Телематическое соглашение Канады',
    editCanadaUserPolicy: 'Редактировать пользовательское соглашение для Канады',
    editDashcamHelp: 'Отредактирована помощь видеорегистратора',
    editDataDeletExplain: 'Редактировать уведомление об удалении данных',
    editExhibitionCategory: {},
    editExhibitionSeries: {},
    editFunctionIntro: {},
    editHelpConfiguration: 'Редактор помогает с конфигурацией',
    editInformation: 'Редактировать информацию',
    editInformationCategory: 'Изменить категорию информации',
    editInformationContent: 'Редактировать информационный контент',
    editKolUserAuthentication: 'Редактирование аутентификации пользователей KOL',
    editModelSeries: 'Изменить серию модели',
    editPicture: 'Редактировать изображение',
    editPushConfiguration: 'Редактировать пуш-уведомления',
    editRemark: 'редактировать примечание',
    editServiceIntroduce: {},
    editShowroomModel: 'Редактирование моделей залов',
    editSuccess: 'Отредактировано успешно',
    editTime: 'Время редактирования',
    editUnbindingCommitment: {},
    editUser: 'Изменить пользователя',
    editVehicleModel: 'Редактировать модель',
    editVehicleModelCategory: 'Изменить категорию автомобиля',
    effecting: 'Ожидание активации',
    effectiveTime: 'Дата вступления в силу',
    electricVehicle: 'Электромобиль',
    email: 'E-mail',
    emailAdress: 'Адрес электронной почты',
    emailAdressTip: 'Примечание: Этот адрес электронной почты используется для связи с клиентами по электронной почте. Пожалуйста, убедитесь, что адрес электронной почты указан правильно',
    emailBindingFailed: 'Не удалось заблокировать эл. почту',
    emailContent: 'Содержание электронного письма',
    emailImportTemplate: 'Шаблон импорта адреса электронной почты',
    emailImportTemplateToDownLoad: 'Адреса электронной почты можно импортировать пакетами. Нажмите, чтобы скачать.',
    emailList: 'Список адресов электронной почты',
    emailManage: 'Управление электронной почтой',
    emailMass: 'Рассылка по электронной почте',
    emailSearch: 'Запрос по электронной почте',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'Электронная почта',
    emailTitle: 'Предмет',
    en_US: 'Английский',
    enableStatus: 'Статус включен',
    enabled: 'давать возможность',
    endTime: 'Время окончания',
    endTimeLargeStartTime: 'Время окончания должно быть позже времени начала',
    enterAnswer: {},
    enterCategory: {},
    enterCodeToSafeAccount: 'Для обеспечения безопасности вашей учетной записи подтвердите данные своей учетной записи, которую вы хотите удалить, и введите свой пароль или проверочный код для подтверждения вашей личности.',
    enterCodeToSafeData: 'Для обеспечения безопасности ваших данных, пожалуйста, подтвердите данные своей учетной записи и введите пароль или проверочный код, чтобы подтвердить вашу личность.',
    enterIntroduceText: {},
    enterLink: {},
    enterPopupTitle: {},
    enterQueryConditionLookData: 'После ввода условий запроса вы можете просмотреть данные',
    enterQuestion: {},
    enterQuestionAndAnswer: {},
    enterSureUrl: {},
    enterTypeOfLanguage: {},
    enterUnbindingCommitment: {},
    entrance: {},
    errorLatAndLon: 'Неправильно указаны широта и долгота, пожалуйста, проверьте',
    errorLocation: {},
    es_ES: 'испанский',
    estimatedTime: 'Расчетное время',
    everySet: 'За настройку',
    examineResultMessage: 'Мы проверим материалы заявки как можно скорее, пожалуйста, вовремя обратите внимание на панель уведомлений или центр сообщений APP.',
    example: 'прецедент',
    exchange: 'Обменять сейчас',
    exchangeDescription1:
      'Уважаемый владелец CFMOTO, ваше транспортное средство успешно привязано. Вы получили 1 год бесплатного пробного периода интеллектуальных услуг. \nПожалуйста, выберите услуги, которые вы хотите активировать: \n- Базовые услуги данных автомобилей \n- MotoPlay \nПожалуйста, ознакомьтесь с условиями и согласитесь с ними. \nПросматривайте «Соглашение об интеллектуальной услуге». \n[Подтвердить]\t',
    exchangeDescription2:
      'Пожалуйста, ознакомьтесь с электронной инструкцией для получения всех сведений о транспортном средстве. Также вы получите 1 год бесплатного пробного периода интеллектуальных услуг CFMOTO RIDE, начиная с даты первого привязывания. \n[Закрыть] [Понятно]',
    exchangeDescription3:
      'У вас доступно XXX км пробега для использования. Списав их, вы продолжите бесплатный доступ к услуге CFMOTO RIDE. Если никаких действий не будет предпринято, данные о пробеге будут храниться в течение 30 дней после отвязки учетной записи. Неиспользованный пробег будет автоматически удален и не подлежит восстановлению после этого периода. \nВы уверены, что хотите списать пробег сейчас?? \n[Да] [Нет] \n\n*Списанные бонусы пробега будут переданы новому владельцу транспортного средства.',
    exchangeDescription4: 'У вас доступно XXX км пробега. Хотите списать пробег, чтобы продолжать \nбесплатно пользоваться интеллектуальной услугой CFMOTO RIDE? \n[Да] [Нет]',
    exchangeDescription5:
      'Уведомление об интеллектуальной услуге \nУважаемый владелец CFMOTO: Бесплатный пробный период интеллектуальной услуги CFMOTO заканчивается через XXX дней. Если вы активируете интеллектуальную услугу, она будет активирована в течение 24 часов. Просьба проверить. \n[Подтвердить]',
    exchangeDescription6: 'Наслаждайтесь удобным маршрутом с MotoPlay, который предлагает дублирование экрана и навигационные услуги на базе Google Maps',
    exchangeRecords: 'История выкупа услуг',
    exchangeServiceTime: 'У вас есть доступный пробег для списания на сервисные часы',
    exchangeSuccess: 'Услуга успешно активирована',
    exhibition: {},
    exhibitionCategory: {},
    exhibitionCategoryList: {},
    exhibitionCategorySearch: {},
    exhibitionSeries: {},
    exhibitionSeriesList: {},
    exhibitionSeriesSearch: {},
    exportContent: 'Содержание экспорта',
    exportExcel: 'Экспортировать в EXCEL',
    exportLengthExceedOfMonth: 'Продолжительность экспорта не должна превышать %s месяцев',
    externalLink: 'Внешняя ссылка',
    failed: 'Ошибка',
    failedToPreview: 'Проверка не пройдена',
    feedBackResut: 'Результаты обратной связи',
    feedBackTime: 'Время обратной связи',
    feedBackVechle: 'Автомобиль',
    feedbackAppQuestion: 'Пожалуйста, подробно опишите время возникновения, версию APP, модель мобильного телефона, путь работы и описание проблемы, чтобы помочь быстро найти и устранить неисправность!',
    feedbackDetails: 'Обратная связь детали',
    feedbackGuideDesc: 'Для получения дополнительной информации свяжитесь с нами через канал обратной связи ниже.',
    feedbackLabelFileList: 'Пожалуйста, загрузите фотографию',
    feedbackMapQuestion: {},
    feedbackMessageSubmitError: 'Сбой обратной связи',
    feedbackOtherQuestion: 'Пожалуйста, опишите, когда это произошло, как это произошло и в чем проблема',
    feedbackReceived: 'Получен отзыв',
    feedbackRecord: 'Запись отзывов',
    feedbackRulesFileListMaxSize: 'загружать слишком большой файл',
    feedbackRulesFileListOverType: 'Неподдерживаемый формат',
    feedbackSubmitTip: 'Если у вас есть какие-либо вопросы или комментарии, вы также можете связаться с Центром обслуживания клиентов CFMOTO в Мексике напрямую через WhatsApp (+52 18115286003) или по электронной почте (servicioalclient@cfmoto.com.mx).',
    feedbackSuggest: 'Добро пожаловать, чтобы сделать ценные предложения, мы будем серьезно рассмотреть ваши идеи',
    feedbackSupplement: 'Пожалуйста, добавьте описание проблемы',
    feedbackText: 'Обратная связь',
    feedbackType: 'Тип обратной связи (один выбор)',
    feedbackVehicleQuestion: 'Пожалуйста, опишите, когда это произошло, как это произошло и в чем проблема',
    female: 'Женщина',
    fileCountExceed: 'Количество документов превышает лимит',
    fileSizeExceed: 'Размер файла превышает лимит',
    fileUploadingPleaceWait: 'Загрузка файла, пожалуйста, подождите',
    finalOperator: {},
    firstBindDate: 'Время первой привязки автомобиля',
    firstMenu: 'меню первого уровня',
    forcedUpgrade: 'Принудительное обновление',
    forgetPassword: 'Не помню пароль',
    fourCarOfNumber: 'Количество пользователей четырехколесного транспортного средства',
    fourWheel: 'Четырехколесные мотоциклы',
    fourWheelConfig: {},
    fourWheeler: 'Четырехколесный',
    fourWheelerMostClicks: 'Модели четырехколесного транспортного средства с наибольшим количеством кликов',
    fourWheelowner: {},
    fr_FR: 'Французский',
    frankfurt: 'Франкфурт',
    freeLastDayBasedata: 'Бесплатная продолжительность стандартной версии',
    freeLastDayMotoplay: 'Бесплатная продолжительность MotoPlay',
    friday: 'Пятница',
    fuctionIntro: {},
    fullscreen: 'Полный экран',
    funServiceIntro: {},
    function: 'Функция',
    functionConfiguration: {},
    functionConfigureTip: 'Функция применима только к сконфигурированным автомобилям под именем импортера или абонентов в подведомственной стране/регионе',
    functionDescription: {},
    functionDetail: {},
    functionIntroduce: 'Описание функции',
    functionSetting: {},
    functionalOverview: 'Обзор функций',
    galleryEntrance: 'Вход в галерею',
    galleryEntranceUploadRules: 'Требования к формату: jpg/jpeg/png, рекомендуемое соотношение 4:3, размер не более 5 МБ.',
    gender: 'Пол',
    generalAgreementText: 'Текст генерального соглашения',
    generalAlarm: 'обычное напоминание',
    geofence: 'Электр. ворота',
    getCarPosition: 'Получить местоположение автомобиля вовремя',
    getCode: 'Отправлять',
    getExchangeRecordsError: 'Не удалось получить историю выкупа',
    goCustomPage: 'Перейдите на пользовательскую страницу',
    goOffline: 'Офлайн',
    goOnline: 'Онлайн',
    goUrlLink: 'Перейти по ссылке URL',
    groupTrail: {},
    groupTrailConfig: {},
    guest: 'нет машины',
    haveTwo: 'Оба',
    havedWrite: 'Заполнен',
    havedWriteAll: 'заполнено.',
    havedWriteAllOrEmpty: 'заполнено или пусто.',
    helpAndFeedback: 'Помощь & обратная связь',
    helpCenter: 'Центр помощи',
    helpConfiguration: 'Разъяснить конфигурацию',
    helpMessageHistoryDelete: 'Удалить все записи поиска?',
    helpful: {},
    hint: 'Намекать',
    historyDelete: 'Удалить все записи поиска?',
    home: 'Глав. Стр.',
    homePage: 'Персональная домашняя страница',
    hour: 'Час',
    hoursAgo: '%s часов назад',
    iWantEnableStoreUserQuery: 'Я хочу активировать поиск пользователей в магазине',
    iWantToPostStatistics: 'Я хочу опубликовать статистику',
    identification: 'Идентификация',
    identificationText: 'Идентификация',
    imageSizeExceed: 'Загрузите изображение шириной до %s',
    imageUploadFailed: 'Не удалось загрузить изображение',
    immediateRelease: 'Немедленный выпуск',
    immediateSend: 'Отправить сейчас',
    imporFailedOfTableHeader: 'Ошибка импорта. Заголовок файла не совпадает',
    import: 'импорт',
    importDetails: 'Детали вопроса',
    importExcel: 'Импортировать EXCEL',
    importFail: 'Импорт не удался',
    importStatus: 'Статус импорта',
    importSuccessful: 'Импорт выполнен успешно',
    importTemplate: 'Загрузка шаблонов',
    importer: 'импортер',
    importerAccountOperationRecord: 'Операция аккаунта импортера и запись входа',
    importerAvatar: 'Аватар импортера',
    importerDisplayName: 'Отображаемое имя импортера',
    importerEnquiry: 'Запрос импортера',
    importerManagement: 'Управление импортёром',
    importerOperationRecords: 'Записи операций импортёра',
    importing: 'Импортируется...',
    inProcess: 'контрмеры',
    inProgress: 'в ходе выполнения',
    individualCenter: 'Личный кабинет',
    informationCategory: 'Категория информации',
    informationCategoryList: 'Список категорий информации',
    informationCategoryQuery: 'Запрос категории информации',
    informationContent: 'Информационный контент',
    informationContentList: 'Список информационного содержания',
    informationCotnentQuery: 'Запрос информационного содержания',
    informationCover: 'Информационная обложка',
    informationDetails: 'Информация Подробнее',
    informationImage: 'обложка',
    informationManagement: 'Управление информацией',
    informationTitle: 'Название информации',
    informer: 'Информатор',
    informerId: 'ID информатора',
    initialPassword: 'Текущий пароль',
    inputAgreementContent: 'Пожалуйста, введите содержание соглашения',
    inputCannotExceed20000: 'Введите не более 20000 символов',
    inputErrorEmoji: 'Пожалуйста, не вводите смайлики',
    installDeviceYouCan: 'Установка данного устройства позволяет',
    installVehicleModelAdd: 'Добавить описание модифицированного автомобиля',
    installVehicleModelDescription: 'Описание модифицированного автомобиля',
    installVehicleModelEdit: 'Изменить описание модифицированного автомобиля',
    instrumentLastedVersion: 'TFT-дисплей уже последней версии',
    instrumentupgrade: 'Обновление TFT-дисплея',
    inteligentServiceReminder: 'Напоминание об интеллектуальном сервисе',
    intelligentInternetServiceIntroduction: 'Введение сервиса',
    intelligentServiceAgreement: 'Соглашение об интеллектуальных сервисах',
    intelligentServices: 'Интеллектуальные услуги (подробности о транспортном средстве, данные о поездках, OTA)',
    introText: {},
    introduction: 'Введение',
    invalidVercode: 'неверный код подтверждения',
    invoicePreview: 'Предварительный просмотр счета',
    invoicing: 'Выставление счета',
    invoicingFailed: 'Не удалось выставить счет',
    invoicingSucceeded: 'Выставление счета успешно завершено',
    iovNotice1: 'Вышеуказанные функции основаны на сетевом устройстве автомобиля (T-Box), пожалуйста, проконсультируйтесь с местным дилером, чтобы купить и установить',
    iovNotice2: 'Вышеуказанные функции отличаются в зависимости от конфигурации каждой модели и региона, где она находится. Пожалуйста, проконсультируйтесь с местным дилером для получения подробной информации.',
    iovNotice3: 'Пожалуйста, заранее сохраните и запишите номер устройства, который потребуется при привязке устройства. После завершения привязки и установки вы сможете воспользоваться дополнительными функциями.',
    isHelpful: 'Это помогает?',
    isStop: {},
    isSupportedChildOwnerOffMapDown: {},
    isSupportedNoOwnerOffMapDown: {},
    isSupportedOffMapDown: {},
    it_IT: 'итальянский',
    iterativeVehicleFunctions: 'Основные части автомобиля могут быть модернизированы онлайн удаленно для непрерывного итерации функций автомобиля',
    jumpSettings: 'Настройки перехода',
    jumpTarget: {},
    jumpToWeb: {},
    jumpUrl: {},
    justNow: 'Только сейчас',
    keySharing: 'Цифровой ключ и совместное использование ключа',
    kolUser: 'Пользователь KOL',
    kolUserList: 'Список пользователей KOL',
    kolUserManagement: 'Управление пользователями KOL',
    kolUserQuery: 'Запрос пользователей KOL',
    language: 'Язык',
    language1: 'Соответствующий язык',
    languages: 'язык',
    lastLoginTime: 'Время последнего входа в систему',
    lastModifiedBy: 'Последнее изменение',
    lastUpdateTime: 'Время последнего обновления',
    latitude: 'Широта',
    launchActivity: 'Опубликовать мероприятие',
    likeNumber: 'Количество лайков',
    linkAddress: {},
    linkUrlDescription: {},
    linkedOrder: 'Связанный заказ',
    listDisplayImages: 'Отображение списка',
    listOfImporters: 'Список импортеров',
    listOfQuestion: {},
    listShowStoreCoverPic: 'Список Показать изображение обложки магазина',
    loadMore: 'Загрузить больше',
    loadSuccess: 'Загрузка завершена',
    loading: 'Загрузка',
    locationFail: {},
    log: 'Журнал',
    login: 'Авторизация',
    loginCountry: 'Страна/регион входа',
    loginSuccessfully: 'Вход успешно выполнен',
    logout: 'Выйдите из аккаунта',
    longitude: 'Долгота',
    loosing: 'Освежающие данные...',
    lowCompatibleVersion: 'Минимальная совместимая версия',
    mail: 'Электронная почта',
    male: 'Мужчина',
    manualReviewStatus: 'Статус ручной проверки',
    mapManage: {},
    marketDataOfdealerStores: 'Рыночные данные дилерских магазинов',
    masteringCyclingData: 'Основные данные о верховой езде',
    maximum: 'Макс.',
    maximumBannerCountTip: 'Максимальное количество баннеров %s может быть онлайн одновременно. Сначала удалите хотя бы один.',
    maximumMileage: 'Максимальный доступный пробег для списания',
    maximumValue: 'Максимальный',
    menuFunctionName: 'Название функции меню',
    menuIcon: 'Значок меню',
    messagePush: 'Пуш-уведомление',
    messagePushDeleteAsk: 'Вы уверены, что хотите удалить это пуш-уведомление?',
    messagePushDownloadTemplate: 'Сначала скачайте шаблон и загрузите его после заполнения файла шаблона.  Размер файла ограничен 2 Мб.  Если отправка не удалась, то необходимо сократить содержание соответствующим образом',
    messageWithdrawAsk: 'Вы хотите отказаться от этого пуш-уведомления?',
    middle: 'середина',
    min: 'Мин.',
    minAgo: '%s мин назад',
    minimum: 'Мин.',
    minimumValue: 'Минимум',
    modelDetail: 'Детали модели',
    modifyFail: 'Модификация не удалась',
    modifyPassword: 'Изменить пароль',
    modifySuccess: 'Изменение успешно завершено',
    monday: 'Понедельник',
    more4pic1video: 'Не более 4 фотографий / 1 видео',
    moreDetailsConsultDealerStore: 'Для получения дополнительной информации, пожалуйста, обратитесь в ваш дилерский центр',
    morning: 'Утро',
    motoPlay: 'MotoPlay (навигационные услуги и дублирование экрана на базе Google)',
    motoPlayAgreement: 'Статус соглашения MotoPlay',
    motoplatNavigationScreen: 'MotoPlay навигация и дублирование экрана',
    motoplayServicePay: 'Оплата MotoPlay',
    motoplayServiceResetTimeRule: 'Время сброса MotoPlay не может быть позже текущего времени',
    motorcycle: 'двухколесный транспорт',
    moveDown: 'Сдвинуть вниз',
    moveLongPressMap: {},
    moveMapSelectPoint: {},
    moveTo: 'Перейти к',
    moveToBottom: 'Сдвинуть до дна',
    moveToTop: 'Сдвинуть в начало',
    moveToTopStatus: 'Закрепить вверху',
    moveTop: 'Закрепить вверху',
    moveUp: 'Сдвинуть вверх',
    multimedia: 'Мультимедиа',
    mustInteger: {},
    mute1Day: 'Возможность отправлять сообщения заблокирована на 1 день',
    mute2Days: 'Возможность отправлять сообщения заблокирована на 2 дня',
    mute30Days: 'Возможность отправлять сообщения заблокирована на 30 дней',
    mute3Days: 'Возможность отправлять сообщения заблокирована на 3 дня',
    mute7Days: 'Возможность отправлять сообщения заблокирована на 7 дней',
    muting: 'Возможность отправлять сообщения заблокирована',
    nameOfImporter: 'Наименование импортера',
    navigation: 'Навигация по карте',
    nearLoginTime: 'Время последнего входа',
    needPopup: 'Нужно всплывающее окно',
    negativeNum: 'Плохой отзыв',
    networkException: 'Исключение сети',
    newAddFail: 'Не удалось добавить',
    newAddSuccess: 'успешно добавлено',
    newBanner: 'Новое Banner',
    newCancellationAgreement: 'Новое заявление на закрытие',
    newEmail: 'Новая электронная почта',
    newEmailEqualsValidate: 'Новая электронная почта не может совпадать с оригинальной',
    newFunctionIntro: {},
    newMenuFunction: 'Функция нов. меню',
    newModelSeries: 'Новая модельная серия',
    newPassword: 'Новый пароль',
    newPasswordNotEqual: 'Дважды введенный новый пароль несовместим, введите его еще раз',
    newQuestionType: {},
    newStoreNumber: 'Количество новых магазинов',
    newTopic: 'Новая тема',
    newUnbindingCommitment: {},
    nextStep: 'Дальше',
    nickName: 'Псевдоним',
    no: 'Нет',
    noContent: 'Нет связанного контента',
    noContent2: 'Предложите изменить ключевые слова или',
    noData: 'Нет данных',
    noExchangeRecord: 'Запись о списании отсутствует',
    noFeedbackRecord: 'В настоящее время нет записей обратной связи.',
    noJump: 'Нет прыжка',
    noLog: 'Нет журнала',
    noMores: 'Данных больше нет',
    noNeedPopup: 'Никаких всплывающих окон не требуется',
    noOkToFeedback: 'Не решено, я хочу оставить отзыв',
    noOwnerScore: 'Рейтинги, не являющиеся владельцами',
    noPass: 'Отклонить',
    noSendPeople: 'Без отправителя',
    noSortingPermission: 'Нет права сортировки',
    noSupportMapDown: {},
    noThisPermission: 'Нет разрешения на эту операцию',
    noUserSelected: 'Пользователь не выбран, невозможно отправить',
    nofiledSeviceContent: {},
    nonOwner: 'Не владелец',
    nonVehicleOwnerCharged: {},
    none: 'Никакой',
    normal: 'В норме',
    notAllowImageAndVideo: 'Видео невозможно выбрать при выборе изображений',
    notAllowed: 'Не допускается',
    notBeLessOrEqual: 'Не должно быть меньше или равно',
    notDeleted: 'не списано',
    notDistributedYet: 'не отправлено',
    notEnabled: 'Не включено',
    notHelpful: {},
    notLessThan: 'Не должно быть меньше',
    notRecommended: 'Не рекомендуется',
    notReleasedYet: 'Пока не опубликовано',
    notStarted: {},
    'notSupportT-Box': 'Извините, ваше транспортное средство не поддерживает T-Box',
    notTop: 'Не закрепить вверху',
    notice: 'Уведомление',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. We are committed to enhancing service quality and implementing innovative improvements, and we have made business adjustments due to this commitment. As of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In its place, we have launched the brand-new CFMOTO RIDESYNC App. We hope you continue to enjoy our services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this app will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that with this service upgrade, you will have a richer and more satisfying user experience. If you encounter any issues or have questions during this process, we will always be here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'Номера версий не могут быть все равными 0.',
    obtainVerificationCode: 'Получение кода проверки',
    officiaAndKolList: 'Список официальных/KOL',
    officialAccount: 'Официальный аккаунт',
    officialAccountAuth: 'Авторизация официального аккаунта',
    officialIrKOLSearch: 'Официальный/KOL-поиск',
    officialKolAuth: 'Официальная/KOL авторизация',
    offline: 'Оффлайн',
    offlineAlready: 'Офлайн',
    offlineTime: 'Время офлайн',
    offlineTimeMustBeGreaterThan: 'Время офлайн должно быть дольше, чем',
    ok: 'OK',
    oldPassword: 'старый пароль',
    onLineAlready: {},
    oneMonths: 'Один месяц',
    oneYear: 'Один год',
    online: 'Онлайн',
    onlyFourWheel: 'Только четырехколесные',
    onlyTwoWheel: 'Только двухколесные',
    openEveryCount: {},
    openEveryDay: {},
    openProductType: {},
    operationRecord: 'Запись операции',
    operationTime: 'Время оперативной работы',
    operations: 'Операции',
    operator: 'Оператор',
    operattor: 'Оператор',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'Дополнительное обновление',
    orderFeedBackNum: 'Количество обращений по заказу',
    orderList: {},
    orderMange: {},
    orderNum: {},
    orderQuestion: 'Опишите время возникновения и детали проблемы, а также загрузите один или несколько скриншотов данной ситуации. В случае проблем с оплатой, пожалуйста, также загрузите запись списания.',
    originalEmail: 'Оригинальная электронная почта',
    otaUpgradeVehicle: 'OTA-обновление автомобиля',
    otaUpgradeVehicleDesc: 'Основные компоненты автомобиля можно модернизировать удаленно, чтобы постоянно улучшать характеристики автомобиля.',
    other: 'Другие',
    over: 'над',
    owner: 'есть машина',
    ownerIdHomepageImage: 'Главная страница удостоверения личности, водительского удостоверения или паспорта, содержащая личную информацию.',
    parameterConfiguration: 'Конфигурация параметров',
    partialImportFailed: 'Частичный импорт не удался',
    pass: 'Одобрить',
    passValidateDeleteAccount: 'Успешное подтверждение личности! Нажмите кнопку "Отправить запрос" внизу, чтобы подать заявку на удаление аккаунта',
    password: 'Пароль',
    passwordRuleText: '8-20 символов, должен содержать заглавные и строчные латинские буквы, цифры, специальные символы',
    passwordRules: 'Правила пароля',
    paySetting: {},
    payStrategy: {},
    paymentLastDayBasedata: 'Оплачиваемая продолжительность стандартной версии',
    paymentLastDayMotoplay: 'Оплачиваемая продолжительность MotoPlay',
    peleaseEnterProvince: 'Пожалуйста, укажите провинцию/штат',
    pendSend: 'В ожидании',
    pending: 'В ожидании.',
    pendingSubmit: 'Ожидается отправка',
    permanentMuting: 'Заглушено навсегда',
    phoneModel: 'Модель',
    phoneNum: 'номер телефона',
    phoneNumber: 'Номер телефона',
    phoneOrEmail: 'Номер телефона/электронная почта',
    phoneOrEmailImportTemplate: 'Шаблон импорта номера мобильного телефона/адреса электронной почты',
    phoneOrEmailNotRegistered: 'Этот номер мобильного телефона или адрес электронной почты не зарегистрирован',
    phoneOrEmailOrUserId: 'Номер мобильного телефона/адрес электронной почты/идентификатор пользователя',
    picture: 'Картина',
    pl_PL: 'Польский',
    pleaseAddImage: 'Пожалуйста, добавьте файлы изображений',
    pleaseAddVideoFile: 'Добавьте пожалуйста видео файлы',
    pleaseEnter: 'Пожалуйста, введите',
    pleaseEnterAccountInfo: 'Пожалуйста, введите данные аккаунта',
    pleaseEnterAmount: {},
    pleaseEnterCity: 'Пожалуйста, введите город',
    pleaseEnterEmail: 'Пожалуйста, введите Ваш адрес электронной почты',
    pleaseEnterEmailAdress: 'Пожалуйста, введите адрес электронной почты',
    pleaseEnterIntro: 'Пожалуйста, введите введение',
    pleaseEnterLatAndLong: 'Пожалуйста, введите широту и долготу',
    pleaseEnterNewPassword: 'Введите новый пароль',
    pleaseEnterPassword: 'Введите пароль',
    pleaseEnterPhone: 'Пожалуйста, введите свой номер телефона',
    pleaseEnterQuestionDescription: 'Пожалуйста, введите описание вашей проблемы',
    pleaseEnterRealname: 'Пожалуйста, введите ваше настоящее имя',
    pleaseEnterRemark: 'Пожалуйста, введите примечания',
    pleaseEnterServePhone: 'Пожалуйста, введите номер телефона службы поддержки',
    pleaseEnterStoreAddressDetail: 'Пожалуйста, введите подробный адрес',
    pleaseEnterStoreIntroduce: 'Пожалуйста, введите введение в магазин',
    pleaseEnterStoreName: 'Пожалуйста, введите название магазина',
    pleaseEnterStoreRemarkName: 'Пожалуйста, введите название примечания магазина',
    pleaseEnterTitle: 'Пожалуйста, введите название',
    pleaseEnterUsername: 'Введите имя пользователя',
    pleaseEnterVercode: 'Введите код проверки',
    pleaseEnterVersion: 'Пожалуйста, введите номер версии',
    pleaseEnterVersionIntroduction: 'Пожалуйста, введите описание версии',
    pleaseEnterVideoDetail: 'Пожалуйста, введите данные видео',
    pleaseEnterVin: 'Пожалуйста, введите VIN',
    pleaseInputWord: 'Введите ключевое слово',
    pleaseLoginFirst: 'Пожалуйста, сначала войдите',
    pleaseRepeatNewPassword: 'пожалуйста, повторите новый пароль',
    pleaseSelect: 'пожалуйста, выбери',
    pleaseSelectAuthAccount: 'Выбрать аккаунт для авторизации',
    pleaseSelectBusinessHours: 'Пожалуйста, выберите часы работы',
    pleaseSelectCity: 'Пожалуйста, выберите город',
    pleaseSelectCountry: 'Пожалуйста, выберите страну',
    pleaseSelectCurrency: {},
    pleaseSelectMatchingMultimediaContent: 'Пожалуйста, выберите подходящий мультимедийный контент',
    pleaseSelectPayChannel: {},
    pleaseSelectProblemWhere: 'Пожалуйста, выберите сценарий, в котором возникает проблема',
    pleaseSelectProducType: {},
    pleaseSelectProvince: 'Пожалуйста, выберите провинцию/штат',
    pleaseSelectQueType: 'Пожалуйста, выберите тип вопроса',
    pleaseSelectReportReason: 'Пожалуйста, выберите причину сообщения',
    pleaseSelectService: 'Сначала выберите услугу',
    pleaseSelectStatus: 'Пожалуйста, выберите статус',
    pleaseSelectStoreType: 'Пожалуйста, выберите тип магазина',
    pleaseSelectTimedSendTime: 'Пожалуйста, выберите время отправки',
    pleaseSelectUserTheList: 'Пожалуйста, выберите абонента из списка',
    pleaseSelectVehicle: 'Пожалуйста, выберите автомобиль',
    pleaseSelectVehicleConfig: {},
    pleaseSelectlinkedOrder: 'Пожалуйста, выберите связанный заказ.',
    pleaseSelectupgradeType: 'Пожалуйста, выберите способ обновления',
    pleaseSureType2: 'Пожалуйста, убедитесь, что все в',
    pleaseUpload: 'Пожалуйста, загрузите',
    pleaseUploadPicVideo: 'Пожалуйста, загрузите фотографии/видео',
    pleaseUserTimeFill: 'Пожалуйста, заполняйте в соответствии со временем конечного пользователя',
    popUpFrequencyType: 'Форма всплывающего окна',
    popUpFrequencyValue: 'Частота всплывающих окон',
    popUpFrequencyValueValid: 'Пожалуйста, выберите дни частоты',
    popUpReminder: 'Показывать ли напоминание',
    popupArea: 'всплывающий диапазон пользователей',
    popupCreate: {},
    popupDayOne: 'Один раз за установленное количество дней',
    popupEdit: {},
    popupFrequency: {},
    popupManagement: {},
    popupOne: {},
    popupPosition: {},
    popupStatus: {},
    popupTarget: {},
    popupTime: {},
    popupTitle: {},
    positiveNum: 'Хорошие отзывы',
    postComment: 'Комментарий к посту',
    postContent: 'Содержание поста',
    postId: 'ID сообщения',
    postList: 'Список постов',
    postManagement: 'Управление постом',
    postSearch: 'Поиск постов',
    posts: 'Посты',
    precautionText1:
      'Hello! As you have learned that we will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States from 08/10/2024, to assist you with this change, please take note of the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the APP to enjoy relevant vehicle services.',
    precautionText3: '2. To ensure a smooth transition to the new service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. Please note that once the service ceases to take effect, you will no longer be able to enjoy any services of the App in the United States. At the same time, we will delete all personal data generated during your use of the App in accordance with relevant laws and regulations. This means that we will not be able to respond to any of your requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may cause inconvenience to you, but we are committed to continuously protecting your data security and privacy. We encourage you to take early action to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy the quality service provided by CFMOTO. If you have any questions or need assistance in this process, please do not hesitate to contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Политика конфиденциальности Подробности содержания',
    privacyPolicy: 'Политика конфид-ти',
    privacyPopupAgree: 'Повторно получить согласие пользователя с политикой конфиденциальности через всплывающее окно',
    privacyVersion: 'Версия политики конфиденциальности',
    privacyVersionList: 'Список версий политики конфиденциальности',
    problemaDes: 'Описание проблемы',
    processMethod: 'Методы обработки',
    processReason: 'Причина обработки',
    processReasonDetails: 'Подробности о причине обработки',
    processRecord: 'Запись обработки',
    processReport: 'Обработка жалоб',
    processSolution: 'Решение обработки',
    processUser: 'Разрешать абонента',
    processed: 'обработан',
    productDetails: {},
    productTime: 'сроки изготовления',
    prohibitDecimalsAndNegative: {},
    pt_PT: 'португальский',
    publishInformation: 'Опубликовать информацию',
    publishPosts: 'Публиковать посты',
    pullBefore: 'Потяните вниз, чтобы обновиться.',
    pulling: 'Релиз обновить сейчас',
    purchaseAndInstall: 'Купить и установить',
    pushConfiguration: 'Настроить пуш-уведомлений',
    pushContent: 'Push-контент',
    pushList: 'Список пуш-уведомлений',
    pushMode: 'Режим пуш-уведомлений',
    pushNow: 'Отправить пуш-уведомление сейчас',
    pushQuery: 'Запросить пуш-уведомления',
    pushRecord: 'Записи о пуш-уведомлениях',
    pushScope: 'Масштаб рассылки пуш-уведомлений',
    pushTime: 'Время отправки пуш-уведомлений',
    pushTimeDifferenceAsk: 'Выбранное вами время отправки может привести к тому, что некоторые пользователи не смогут получить это сообщение из-за разницы во времени. Вы уверены, что хотите сохранить?',
    pushTitle: 'Заголовок пуш-уведомлений',
    pushed: 'Толкнул',
    pushing: 'В процессе пуш-уведомлений',
    quantity: 'Количество',
    query: 'Искать',
    question: {},
    questionInquiry: {},
    questionType: 'Тип вопроса',
    questionTypeList: {},
    questionTypeTemplate: {},
    quickRelease: 'Быстрое опубликование',
    ranking: 'Рейтинг',
    ratingWarn1:
      'Для пользователей-владельцев транспортных средств управление интеллектуальными услугами, соответствующее стране/региону в фоновом режиме управления, не было включено или срок действия услуги интеллектуальных услуг не истек после включения. Транспортное средство подключено к сети и имеет',
    ratingWarn2: 'или более полных записей о поездках (начало и конец каждой поездки являются событием, о котором сообщается), всплывающее окно появится, когда пользователь выйдет из My Cycling и вернется на домашнюю страницу.',
    reUpgrade: 'Повторить попытку',
    readAgree: 'Прочитайте и согласитесь с',
    readAndAgree: 'Пожалуйста, прочитайте и согласитесь',
    readAndAgreeTo: 'Я прочитал и согласен с',
    readDeleteStep: 'понять, какие типы данных мы будем удалять или хранить, а также любые дополнительные сроки хранения',
    realname: 'Настоящее имя',
    reasonForReport: 'Причина',
    receiveCarReminderMessage: 'Получать оповещения об автомобиле',
    rechargeAmount: {},
    rechargeChannel: {},
    rechargeStatus: {},
    rechargeTime: {},
    recharged: {},
    recipients: 'Получатель',
    recipientsNum: 'Область получателя',
    recommended: 'Рекомендуется',
    recommendedStatus: 'Рекомендуемый статус',
    redeemableServiceHours: 'Обмениваемые часы сервиса',
    redemptionMileage: 'Доступный пробег для списания',
    redemptionRatio: 'Коэффициент списания',
    redemptionTime: 'Время списания',
    redirectUrl: {},
    refreshInterval: 'Время обновления',
    refreshSend: 'Отправить',
    refundFailed: {},
    refunded: {},
    refunding: {},
    refused: 'Отклонено',
    registerDate: 'Время регистрации',
    rejected: 'Отклонено.',
    releaseContent: 'Опубликовать пост',
    releaseMethod: 'Способ публикации',
    releaseMute: 'Снимать бан',
    releaseTime: 'Время релиза：',
    released: 'Опубликовано',
    releasedBy: 'Выпущено',
    remainServiceHavExpired: 'Осталось время до истечения срока действия интеллектуальной службы',
    remainingAvailableMileage: 'Оставшийся доступный пробег',
    remark: 'Примечания',
    rememberPassword: 'Не помню пароль',
    reminder: 'Напоминание',
    remove: 'Удалить',
    removeOnlinUpgrade: 'Удаленное онлайн обновление автомобиля',
    repeatNewPassword: 'Повторите новый пароль',
    replaceTBOX: 'Заменить TBOX',
    replied: 'Ответила',
    reply: 'Ответить',
    report: 'Отчет',
    reportList: 'Список отчетов',
    reportManagement: 'Управление жалобами',
    reportReason: 'Причина жалобы',
    reportReasonDetails: 'Подробная информация о причине жалобы',
    reportReasonPlaceholder: 'Напишите, что вы хотите сообщить, 0-1500 слов',
    reportSearch: 'Поиск жалобы',
    reportSuccessful: 'Сообщение успешно, мы рассмотрим его как можно скорее',
    reportTime: 'Время жалобы',
    reportType: 'Тип доклада',
    reportedContent: 'Содержание, на которого жаловаться',
    reportedUser: 'Абонент, на которого жаловаться',
    reportedUserId: 'ID абонента, на которого жаловаться',
    requestTimedOut: 'Истекло время запроса',
    resend: 'Повторно отправить',
    resendTo: 'Повторно отправить в',
    reset: 'Сброс',
    resetItem: 'Параметр сброса',
    resetTime: 'Время сброса интеллектуальных услуг',
    resetWarn: 'После сброса бесплатный период использования интеллектуальных услуг данного транспортного средства будет пересчитан и вступит в силу на основе текущего времени (времени браузера). Подтвердите сброс?',
    return: 'Возвращение',
    review: 'Проверка',
    reviewApproved: 'Проверка пройдена',
    richText: {},
    ro_RO: 'румынский',
    roleDescription: 'Описание роли',
    roleName: 'Название роли',
    rolePermission: 'Права роли',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'Русский',
    safeRemind: 'Для защиты безопасности вашего аккаунта, пожалуйста, не предоставляйте здесь конфиденциальную личную информацию, такую как пароли от аккаунтов и т.д.',
    satelliteMap: 'спутниковая карта',
    saturday: 'Суббота',
    save: 'Сохранить',
    saveAndPreview: 'Сохранить и просмотреть',
    saveAsDraft: 'Сохранить как черновик',
    saveFail: 'Не удалось сохранить',
    savePicture: 'Сохранить изображение',
    saveSettings: 'Сохранить настройки',
    saveSuccess: 'Сохранено успешно',
    saveVideo: 'Сохранить видео',
    scanQrcodePreview: 'Отсканируйте QR-код ниже с помощью своего мобильного телефона для предварительного просмотра.',
    screenNavigationGuidance: 'Інструкцыя па наладзе',
    sdkStatement: 'Заявление SDK',
    search: 'Поиск',
    searchRecords: 'Исторический поиск',
    secondaryMenu: 'вторичное меню',
    securityMessage: 'Вышеуказанная информация используется только для проверки личности, CFMOTO обеспечивает защиту вашей информации.',
    securityServices: 'Услуги безопасности (определение местоположения в реальном времени, геозоны, сигнализация о неисправностях)',
    select: 'Выбрать',
    selectAccount: 'Выбрать аккаунт',
    selectAll: 'Выбрать все',
    selectAuthentication: 'Выберите аутентификацию',
    selectChannelType: 'Пожалуйста, выберите канал обратной связи',
    selectCountry: 'Выбрать страну',
    selectData: 'Пожалуйста, выберите данные, которые вы хотите удалить, и нажмите кнопку "Отправить" внизу, чтобы отправить запрос на удаление данных.',
    selectDate: 'Выберите дату',
    selectEnableStatus: {},
    selectFeedBackState: 'Выберите статус обработки отзыва',
    selectFeedbackType: 'Пожалуйста, выберите тип обратной связи',
    selectJumpTarget: {},
    selectLanguage: 'Выберите язык',
    selectOneCarType: 'Выберите хотя бы одну модель',
    selectPoint: {},
    selectPopupFrequency: {},
    selectPopupPosition: {},
    selectPopupTarget: {},
    selectPopupTime: {},
    selectRejectReason: 'Пожалуйста, выберите причину отказа',
    selectTheLanguage: 'Язык',
    selectTime: 'выберите время',
    selectUser: 'Выберите пользователей',
    selectVehicle: 'Выберите автомобиль',
    selectedMileage: 'Выбранный пробег',
    selectedMileageRedemption: 'Выберите пробег для списания',
    selectionOfImporter: 'Выбор импортера',
    sendNumberDescription: 'количество действительных устройств, для которых AWS Cloud создал задачи отправки;',
    sendNumberDescription0: 'Среди эффективных целевых устройств, сервер Aurora позволяет успешно создавать количество устройств для отправки заданий по пуш-уведомлениям',
    sendNumberVolume: 'Количество отправок',
    sendTo: 'Отправить в',
    sendType: 'Режим отправки',
    sendUserNum: 'Количество отправок',
    sending: 'При отправке',
    serial: 'Нет.',
    seriesBackground: {},
    seriesDesc: {},
    seriesIntroduction: 'Серия презентаций',
    seriesName: {},
    seriesShowcase: 'Серия диаграмм',
    seriesUplodImgRule: {},
    seriousAlarm: 'серьезное напоминание',
    serviceDays: 'Дни сервиса',
    serviceDetail: 'Детали интеллектуальной услуги',
    serviceExpiration: 'Срок действия ваших интеллектуальных услуг истёк',
    serviceHavExpired: 'Срок действия интеллектуальных услуг истёк',
    serviceIntroduction: 'Введение сервиса',
    serviceReset: 'Сброс Интеллектуальной услуги',
    serviceText: 'Услуги',
    settingSuccess: 'Установлено успешно',
    shareNumber: 'Количество акций',
    sheet: 'Чжан',
    show: 'Посмотреть',
    showPicturesOfVideos: 'Показать фотографии/видео',
    showToast1: 'Оставшегося пробега недостаточно для выкупа 1 дня услуги',
    showToast2: 'Минимальный срок выкупа услуги – 1 день',
    showToast3: 'Параметр отсутствует или равен null',
    showroomModel: 'Модель зала',
    showroomModelList: 'Список моделей выставочного зала',
    showroomModelQuery: 'Запрос модели выставочного зала',
    showroomUploadRules: 'Требование к формату изображения — jpg/jpeg/png, соотношение изображения — 9:19,5, размер не превышает 5 МБ, размер видео не превышает 50 МБ.',
    signOut: 'Автоматическое прекращение',
    singapore: 'Сингапур',
    sixMonths: 'Шесть месяцев',
    slideToRight: 'проведите пальцем вправо',
    smartServices: 'Умные услуги',
    someUser: 'Некоторые пользователи',
    sort: 'Сортировать',
    source: 'Источник',
    sr_YU: 'сербский',
    standardAgreement: 'Статус соглашения Standard Edition',
    startCalculateTimeBasedata: 'Время сброса стандартной версии',
    startCalculateTimeMotoplay: 'Время сброса MotoPlay',
    startChecking: 'Начать проверку.',
    startTime: 'Время запуска',
    statisticalTime: 'Статистическое время',
    status: 'Статус',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. First, you can click the button below [Download CFMOTO RIDESYNC] or directly open Apple Store/Google Play to search and download CFMOTO RIDESYNC App;',
    stepText3: '2. After downloading and installing, please open the CFMOTO RIDESYNC App to enter the login page. On this page, you need to log in with your existing CFMOTO RIDE account and password;',
    stepText4:
      '3. When you enter your account and password correctly, the App will pop up a prompt window asking whether to start the data migration. When you click OK, the data migration starts immediately and this process is uninterrupted. If you select "Cancel" in this step, you will not be able to continue logging into the App.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If that fails, contact it@cfmoto.com',
    stepText6:
      '5. After the data migration is completed, you will automatically enter the vehicle homepage of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the App normally, and you will be able to access all the data you previously retained in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log in the CFMOTO RIDESYNC App with your CFMOTO RIDE account to ensure successful data migration. If you choose to register a new account or log in with another account, your data will not be migrated. In addition, after successful data migration, your original CFMOTO RIDE account will no longer support login to the CFMOTO RIDE App. Please operate carefully to ensure the safe migration of your data.',
    stop: {},
    store: {},
    storeAddressCountryTip: 'Примечание: Этот адрес магазина - единственная основа для того, чтобы пользователи могли найти вас. Пожалуйста, заполните внимательно, чтобы убедиться в правильности адреса',
    storeAddressDetail: 'Адрес магазина',
    storeAddressDetailTip: 'Пример: подробный адрес: г. Ханчжоу, зона экономического развития Юйхан, ул. Учжоу-лу , д.116',
    storeAddressPosition: 'Широта и долгота',
    storeAddressPositionTip: 'Долгота: целая часть долготы - целое число от -180 до 180, десятичная часть - не более 15 знаков после запятой.\nШирота: целая часть широты - целое число от -90 до 90, а десятичная часть - не более 15 знаков после запятой.',
    storeBusinessType: 'Тип магазина',
    storeImage: 'Изображение магазина',
    storeImportTemplateText: 'Пожалуйста, загрузите шаблон, заполните информацию о магазине дилера в файле шаблона, затем загрузите файл; размер файла ограничен до 1 МБ; если отправка не удалась, уменьшите содержание или загружайте партиями',
    storeIntroduce: 'Введение в магазин',
    storeList: 'Список магазина',
    storeMange: 'Управление магазином',
    storeName: 'Название магазина',
    storeNameTip: 'Примечание: Выберите язык, поддерживаемый системой, и введите название магазина',
    storeQueryUserStatistics: 'Статистики пользователя запроса в магазине',
    storeRemarkName: 'Название примечания магазина',
    storeRemarkNameTip: 'Примечание: Если язык, поддерживаемый системой, не соответствует вашим потребностям, вы можете ввести здесь название примечания магазина на нужном вам языке.',
    storeSearch: 'Запрос к магазинам',
    storeServicePhone: 'Номер телефона службы',
    storeServicePhoneTip: 'Примечание: Этот номер используется для телефонной связи с клиентами, пожалуйста, убедитесь, что номер телефона указан правильно.',
    storeServiceTime: 'Время открытия',
    storeStatistics: 'Статистика магазина',
    storeUploadImageRequire: 'Требования к формату изображения для jpg/jpeg/png, рекомендуется, чтобы размер одного изображения не превышал 5MB, за один импорт до 9, можно импортировать более одного раза, общее количество не более 9',
    storefront: 'Магазин',
    submissionFailed: 'Отправка не удалась, пожалуйста, попробуйте снова.',
    submit: 'Отправить',
    submitAccountDeleteApply: 'Отправьте запрос на удаление учетной записи',
    submitDataDeleteApply: 'Отправьте запрос на удаление данных',
    submitFeedback: 'Отправить отзыв',
    submitForReview: 'Отправить на проверку',
    submitted: 'Представлено',
    successful: 'Успешно',
    sunday: 'Воскресенье',
    supportMapDown: {},
    supportedChannel: {},
    sureAgree: 'Согласны или нет?',
    sureBackApply: 'Подтвердить отзыв заявки на удаление учетной записи',
    sureDelete: 'После удаления его невозможно восстановить. Вы уверены, что хотите это удалить',
    sureDeleteData: 'Вы уверены, что хотите удалить выбранные данные? После подтверждения данные будут немедленно удалены и не смогут быть восстановлены',
    sureDeleteSeries: {},
    sureDeleteSetting: {},
    sureDeleteStoreInfo: 'Подтвердить удаление информации об этом магазине? После удаления информация не подлежит восстановлению',
    sureReject: 'Вы уверены, что хотите отказать?',
    sureSuspend: 'Отправка прекратится после завершения. Вы уверены, что хотите прекратить действие',
    suspend: 'Прекратить',
    sv_SE: 'Шведский',
    switchLanguage: 'Переключение языков',
    system: 'Система',
    systemBusy: 'Система занята, повторите попытку позже',
    systemVersion: 'версия системы',
    tboxInstall: 'Установка Tbox после установки',
    tboxIntro: 'T-Box является ключевым устройством для реализации функции интеллектуального сетевого подключения транспортных средств.',
    teamConfigTip: {},
    threeMonths: 'Три месяца',
    thursday: 'Четверг',
    time: 'Время',
    timeSend: 'Отправка по времени',
    timedOffline: 'Офлайн в установленном времени',
    timedPush: 'Запланированные пуш-уведомления',
    timedRelease: 'Запланированный выпуск',
    timedSendTime: 'Отправить время',
    tips: 'Советы',
    title: 'заглавие',
    to: 'В',
    toBeReleased: 'Будет опубликовано',
    topMenu: 'верхнее меню',
    topicContent: 'Содержание темы',
    topicList: 'Список тем',
    topicManagement: 'Управление темами',
    topicSearch: 'Поиск темы',
    topicTitle: 'Название темы',
    totalAndlLayoutOfStores: 'Общее количество и расположение магазинов',
    totalClicks: {},
    totalNumber: 'Всего раз',
    tr_TR: 'турецкий',
    triggerNum: 'Количество триггеров',
    tuesday: 'Вторник',
    turnOn: 'Открыть',
    twoCarAndFourCarOfNumber: 'Количество пользователей двухколесного и четырехколесного транспортного средства',
    twoCarOfNumber: 'Количество пользователей двухколесного транспортного средства',
    twoWheelConfig: {},
    twoWheeler: 'Двухколесный транспорт',
    twoWheelerAndFourWheeler: 'Двухколесные и четырехколесные',
    twoWheelerMostClicks: 'Модели двухколесного транспортного средства с наибольшим количеством кликов',
    twoWheelowner: {},
    type: 'Тип',
    typeMessage: 'тип обратной связи',
    types: 'Тип',
    unbind: 'Отвязано',
    unbindingCommitment: {},
    unbindingLabelRealName: 'Ваше полное имя',
    unbound: 'Свободный',
    understandRealtimeConditions: 'Получайте вибрацию автомобиля и электронные сообщения с напоминаниями о въезде и выезде из автомобиля, а также отслеживайте состояние автомобиля в режиме реального времени.',
    uninstallTboxDesc: 'Для автомобилей, на которых не установлен T-Box, после привязки можно просмотреть основную информацию об автомобиле, такую как номер рамы, номер двигателя и электронное руководство.',
    unitCurrencyPer: {},
    unitMonth: 'Месяц',
    unlimited: 'Без ограничений',
    unpaid: {},
    unprocessed: 'не обработано',
    unresolved: 'Все еще не можете решить? Нажмите',
    unspecified: 'Конфиденциальность',
    upToTopics: 'Можно добавить до %s тем',
    updateAuthenticationTime: 'Обновление времени аутентификации',
    updateBy: 'Средство обновления',
    updateSuccess: {},
    updateTime: 'Время обновления',
    updating: 'обновление',
    upgradeAgainDescription: 'Задача обновления была повторно отправлена. Пожалуйста, следуйте 【Руководству】 в верхней части текущей страницы, чтобы подключить сеть TFT-дисплея для обновления.',
    upgradeAssistant: 'Помощь',
    upgradeDescription: 'Когда будет найдена новая версия, следуйте 【Руководству】 в верхней части текущей страницы, чтобы подключить сеть TFT-дисплея для обновления.',
    upgradeSuccessful: 'Обновление успешно',
    upgradeType: 'Обновить метод',
    upload: 'Загрузить',
    uploadDisplayPicture: {},
    uploadFail: 'Загрузка не удалась',
    uploadFailed: 'Загрузка не удалась, попробуйте другую сеть',
    uploadFailedOfTry: 'Загрузка не удалась, попробуйте еще раз',
    uploadFileMore1M: 'Размер загружаемого файла не превышает 1M',
    uploadFiles: 'Загрузить файл',
    uploadImageRules1To1: 'Формат изображения требует jpg / jpeg/png, соотношение 1: 1, размер не более 5 МБ',
    uploadLog: 'Загрузить журнал',
    uploadPicture: 'Загрузить изображение',
    uploadQuantityExceed: 'Количество загрузок превышает лимит',
    uploadSuccessful: 'Загрузить успешно',
    uploadTime: 'Время загрузки',
    uploadTip556_740: {},
    uploadVideoRules: 'Поддерживается только однократная загрузка видеофайлов. Рекомендуется, чтобы размер одного видео не превышал 50 МБ.',
    uploadVideoRules4To3: 'Поддержка видеоформатов, рекомендованное соотношение 4: 3, размер не более 50 МБ',
    urlLink: 'URL-ссылка',
    user: 'Пользователь',
    userAccount: 'Учетная запись пользователя',
    userEmail: 'электронная почта',
    userGender: 'Пол пользователя',
    userId: 'Идентификатор пользователя',
    userIdTemplate: 'Идентификатор пользователя Импорт шаблона',
    userIdentity: 'ID пользователя',
    userLocalTime: 'Время окончания для пользователя',
    userLogin: 'Вход в систему',
    userMobilePhone: 'мобильный телефон',
    userModel: 'Модель пользователя',
    userName: 'Имя пользователя',
    userName1: {},
    userNickname: 'Никнейм пользователя',
    userNum: 'Номер пользователя',
    userPhone: 'Номер мобильного телефона',
    userRealName: 'настоящее имя',
    userReply: 'Ожидающий ответ пользователя',
    userStatus: 'Статус абонента',
    userType: 'Тип пользователя',
    userUnbind: 'Отвязка пользов.',
    users: 'пользователи',
    vacationTime: 'Время отпуска',
    validNumberVolume: 'Количество участников целевой аудитории',
    validNumerDescription: 'количество устройств, оставшихся после фильтрации выбранной целевой группы для отправки задачи',
    validateAfter24Hours: 'Поддерживается только выбор будущего времени в течение 24 часов',
    validateEmail: 'Неверный формат адреса электронной почты, пожалуйста, проверьте.',
    validateImageRadio: 'Требования к формату файла изображений: %s, масштаб изображения: %s, не более %s',
    validateImageSize: 'Требования к формату файла изображений: %s, рекомендуемый размер изображения: %s, не более %s',
    validatePhone: 'Ошибка формата номера телефона, пожалуйста, проверьте',
    validateVideo: 'Требования к формату файла видео: %s, не более %s',
    validateVin: 'Неверный VIN, пожалуйста, проверьте.',
    validationCodeError: 'Ошибка кода проверки',
    vechicleFirstBindTime: 'Фактическое время первой привязки транспортного средства',
    vehicleAlarmDetails: 'Подробности напоминания',
    vehicleBindDuration: 'Продолжительность привязки транспортного средства',
    vehicleBrochure: 'Брошюра об автомобиле',
    vehicleColor: 'Цвет автомобиля',
    vehicleDetails: 'сведения о вагонах',
    vehicleDrivingLicense: 'Свидетельство о регистрации транспортного средства.',
    vehicleFaultDetails: 'детали неисправности вагона',
    vehicleGallery: 'Галерея',
    vehicleGalleryEntranceConfiguration: 'Страница выставочного зала мотоциклов в приложении и изображения входа в галерею транспортных средств взяты из следующей конфигурации. Убедитесь, что все три изображения завершены в конфигурации.',
    vehicleGalleryEntranceSettings: 'Настройки входа в галерею автомобилей',
    vehicleGalleryUploadRules: 'Требование к формату изображения — jpg/jpeg/png. Рекомендуется, чтобы размер одного изображения не превышал 5 МБ. Одновременно можно импортировать не более 10 изображений. Допускается множественный импорт.',
    vehicleIdHomepageImage: 'Главная страница свидетельства о регистрации транспортного средства с указанием имени владельца и VIN.',
    vehicleModel: 'Модель автомобиля',
    vehicleModelAlbum: 'Модельный альбом',
    vehicleModelCategorySort: 'Сортировать по категории автомобиля',
    vehicleModelDescription: 'Описание модели',
    vehicleModelList: 'Список моделей',
    vehicleModelManagement: 'Управление моделями транспортных средств',
    vehicleModelName: 'Название модели',
    vehicleModelQuery: 'Запрос модели автомобиля',
    vehicleModelSeries: 'Модельный ряд',
    vehicleModelSorting: 'Сортировка моделей',
    vehicleModelType: 'Тип модели',
    vehicleName: 'Название автомобиля',
    vehicleNetworkEquipment: 'Сетевое устройство автомобиля',
    vehicleOutboundCountry: 'Страны вывоза автотранспортных средств',
    vehicleRemark: 'Примечание для вагонов',
    vehicleShareInstruction: 'Инструкции по совместному использованию автотранспортных средств',
    vehicleShareInstructionAdd: 'Пояснения по совместному использованию новых автотранспортных средств',
    vehicleShareInstructionEdit: 'Изменить инструкции по совместному использованию автотранспортных средств',
    vehicleType: 'Номер двигателя',
    vehicleTypeSplicing: 'Модель обратной связи',
    vehicleUnbindingInstructions: 'Инструкция по подаче заявления на отвязку автомобиля',
    verifyCodeSendFail: 'Ошибка при отправке кода подтверждения',
    verifyCodeSendSuccess: 'Проверочный код успешно отправлен',
    versionCode: 'Номер версии',
    versionIntroduction: 'Введение в версию',
    versionManage: 'Управление версиями',
    versionManageList: 'Список управления версиями',
    versionMangeTip:
      'Примечание. Не разрешается создавать версию, превышающую номер версии, опубликованный в настоящее время на рынке приложений! Персоналу по эксплуатации и техническому обслуживанию необходимо дождаться выпуска последней версии в Google Play или App Store, а затем создать записи версии, соответствующие номеру последней версии. Создание записей заранее не допускается.',
    versionPattern: 'Номер версии можно ввести только как целое число от 0 до 999.',
    versionRequired: 'Номер версии не может быть пустым',
    vhDataBasicService: 'Основной сервис данных автомобиля',
    video: 'видео',
    videoContent: 'Видеоконтент',
    videoCover: 'Видео обложка',
    videoDetail: 'Подробности видео',
    videoDisplayImages: 'Видео дисплей',
    videoFile: 'Видео файл',
    videoGuide: 'Конфигурация загрузки видео',
    videoImageValidate: 'Требования к формату файла изображения: png jpg jpeg, соотношение сторон 16:9, размер не более 5 МБ.',
    videoList: 'Список видео',
    videoMaxSizeValidate: 'Размер видео не может превышать 150 МБ.',
    videoSizeExceed: 'Пожалуйста, загрузите видео шириной до %s',
    viewAllComment: 'Посмотреть все комментарии',
    viewCount: 'количество просмотров',
    viewCurrentLocation: 'Откройте приложение для просмотра текущего местоположения автомобиля в любое время',
    viewCurrentLocation2: 'Откройте приложение, чтобы просмотреть текущее местоположение автомобиля в любое время, что удобно для поиска транспортных средств с близкого расстояния.',
    viewDetails: 'Смотрите подробнее',
    viewFeedBackRecords: 'Просмотр записей отзывов',
    viewLocation: 'Откройте приложение, чтобы проверить местоположение автомобиля в любое время.',
    viewModel: {},
    viewPush: 'Смотреть пуш',
    viewSeries: {},
    viewVehicleInfomation: 'Поддержка для просмотра ежедневной дорожки, пробега, продолжительности, скорости и другой информации о транспортном средстве',
    views: 'Взгляды',
    vin: 'VIN',
    virginia: 'Вирджиния',
    waitForReview: 'Ожидание проверки',
    waitUploading: 'Загрузка, пожалуйста, подождите',
    waitingManualReview: 'Ожидание ручной проверки',
    waitingOnline: {},
    waitingPush: 'Ожидающий',
    wednesday: 'Среда',
    whatOTA: 'Что такое ОТА?',
    whyUseNavigation: 'Как пользоваться навигацией',
    whyUseSetting: 'Как сделать общие настройки приложения',
    withCountry: 'Страна/регион(IP)',
    withInformation: 'С информацией',
    withTBOX: {},
    withdrawn: 'Уже отозвано',
    withoutCarOfNumber: 'Количество пользователей без автомобиля',
    withoutTBOX: {},
    writeAccountToPass: 'Заполните информацию о счете и пройдите проверку личности',
    year: {},
    yes: 'Да',
    youHaveFeedbackMessage: 'У вас есть ** отзывы пользователей, которые не были эффективно рассмотрены, пожалуйста, примите меры вовремя.',
    youthVehicleOwner: {},
    yoyGrowth: 'Увеличение по сравнению с предыдущим годом',
    zh_CN: 'Китайский',
  },
};
